import React from "react";
import { graphql, useFragment } from "react-relay";
import { View } from "react-native";
import { Box } from "arkh";
import { PillIndicator } from "../PillIndicator";
import { WorkspaceTodoListItemStatus_todo$key } from "./__generated__/WorkspaceTodoListItemStatus_todo.graphql";
import { StoresIndicator } from "./StoresIndicator";

export function WorkspaceTodoListItemStatus(props: {
  workspaceTodo: WorkspaceTodoListItemStatus_todo$key;
}) {
  const workspaceTodo = useFragment(
    graphql`
      fragment WorkspaceTodoListItemStatus_todo on TodoWorkspace {
        status
        todoCount(workspaceId: $workspaceId)
        todosCompletedCount(workspaceId: $workspaceId)
      }
    `,
    props.workspaceTodo
  );
  return (
    <View>
      <StoresIndicator
        status={workspaceTodo.status === "PUBLISHED" ? "ACTIVE" : "INACTIVE"}
        totalStores={workspaceTodo.todoCount}
        value={workspaceTodo.todosCompletedCount}
      />
      {workspaceTodo.status === "DRAFT" ? null : (
        <Box spaceTop="xsmall">
          <PillIndicator
            percentage={
              (workspaceTodo.todosCompletedCount / workspaceTodo.todoCount) *
              100
            }
          />
        </Box>
      )}
    </View>
  );
}
